export default __webpack_public_path__ + "static/media/district-white.a86f3774.svg";